//Ustawia wartość w zależności od zadanej wartości/selector-a
(function($) {
    $.fn.selectOnClick = function(options) {
        var settings = {};
        settings = $.extend(settings, options);
        return this.each(function(index) {
            var $this = $(this);
            $this.on("click.selectOnClick", function() {
                $this.select();
            });
            return $this;
        });
    };
})(jQuery);
